var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolicitudVacaciones({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#39375E"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFBEB"
    },
    d: "M467.83,139.6v260.19c-15.02,22.08-33.4,41.7-54.41,58.1H98.58c-21.01-16.4-39.39-36.02-54.41-58.1 V139.6c0-15.31,8.8-28.56,21.61-34.98c5.26-2.63,11.19-4.11,17.47-4.11h345.5C450.33,100.51,467.83,118.01,467.83,139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E0C9"
    },
    d: "M467.83,301.9v97.89c-15.02,22.08-33.4,41.7-54.41,58.1H311.84l10.42-29.54l14.08-39.91l16.93-47.99 l7.38-2.48l67.2-22.62L467.83,301.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD544C"
    },
    d: "M467.834,159.056H44.166V81.059c0-21.588,17.5-39.088,39.088-39.088h345.491 c21.588,0,39.088,17.5,39.088,39.088v77.997H467.834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C63B38"
    },
    d: "M463.71,63.586c-6.416-12.814-19.659-21.616-34.964-21.616h-25.759h-54.76h-206.07h-54.76h-4.143 c-21.588,0-39.088,17.501-39.088,39.088v77.997h21.616V82.77c0-10.595,8.589-19.184,19.184-19.184h2.432v40.169 c0,15.122,12.258,27.38,27.38,27.38l0,0c15.122,0,27.38-12.258,27.38-27.38V63.586h206.07v40.169c0,15.122,12.258,27.38,27.38,27.38 l0,0c15.121,0,27.38-12.258,27.38-27.38V63.586H463.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D75C"
    },
    d: "M125.585,131.135L125.585,131.135c-15.122,0-27.38-12.258-27.38-27.38V27.38 c0-15.122,12.258-27.38,27.38-27.38l0,0c15.121,0,27.38,12.258,27.38,27.38v76.376C152.965,118.877,140.707,131.135,125.585,131.135 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8C63A"
    },
    d: "M119.821,103.756V27.38c0-11.283,6.826-20.968,16.572-25.16C133.077,0.793,129.424,0,125.585,0l0,0 c-15.122,0-27.38,12.258-27.38,27.38v76.376c0,15.122,12.258,27.38,27.38,27.38l0,0c3.839,0,7.492-0.793,10.808-2.22 C126.647,124.724,119.821,115.038,119.821,103.756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D75C"
    },
    d: "M386.415,131.135L386.415,131.135c-15.122,0-27.38-12.258-27.38-27.38V27.38 c0-15.122,12.258-27.38,27.38-27.38l0,0c15.121,0,27.38,12.258,27.38,27.38v76.376C413.795,118.877,401.536,131.135,386.415,131.135 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8C63A"
    },
    d: "M380.651,103.756V27.38c0-11.283,6.826-20.968,16.572-25.16C393.907,0.793,390.254,0,386.415,0l0,0 c-15.121,0-27.38,12.258-27.38,27.38v76.376c0,15.122,12.258,27.38,27.38,27.38l0,0c3.839,0,7.492-0.793,10.808-2.22 C387.477,124.724,380.651,115.038,380.651,103.756z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E0C9"
    },
    d: "M145.76,252.544H91.72c-4.178,0-7.566-3.387-7.566-7.566v-54.039c0-4.178,3.387-7.566,7.566-7.566 h54.039c4.178,0,7.566,3.387,7.566,7.566v54.039C153.325,249.157,149.938,252.544,145.76,252.544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E0C9"
    },
    d: "M237.266,252.544h-54.039c-4.178,0-7.566-3.387-7.566-7.566v-54.039 c0-4.178,3.387-7.566,7.566-7.566h54.039c4.178,0,7.566,3.387,7.566,7.566v54.039C244.832,249.157,241.445,252.544,237.266,252.544 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E0C9"
    },
    d: "M328.773,252.544h-54.039c-4.178,0-7.566-3.387-7.566-7.566v-54.039 c0-4.178,3.387-7.566,7.566-7.566h54.039c4.178,0,7.565,3.387,7.565,7.566v54.039C336.338,249.157,332.951,252.544,328.773,252.544 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E0C9"
    },
    d: "M420.28,252.544h-54.04c-4.178,0-7.566-3.387-7.566-7.566v-54.039c0-4.178,3.387-7.566,7.566-7.566 h54.039c4.178,0,7.565,3.387,7.565,7.566v54.039C427.845,249.157,424.458,252.544,420.28,252.544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E0C9"
    },
    d: "M145.76,340.448H91.72c-4.178,0-7.566-3.387-7.566-7.566v-54.039c0-4.178,3.387-7.565,7.566-7.565 h54.039c4.178,0,7.566,3.387,7.566,7.565v54.039C153.325,337.061,149.938,340.448,145.76,340.448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E0C9"
    },
    d: "M237.266,340.448h-54.039c-4.178,0-7.566-3.387-7.566-7.566v-54.039 c0-4.178,3.387-7.565,7.566-7.565h54.039c4.178,0,7.566,3.387,7.566,7.565v54.039C244.832,337.061,241.445,340.448,237.266,340.448 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E0C9"
    },
    d: "M328.773,340.448h-54.039c-4.178,0-7.566-3.387-7.566-7.566v-54.039 c0-4.178,3.387-7.565,7.566-7.565h54.039c4.178,0,7.565,3.387,7.565,7.565v54.039C336.338,337.061,332.951,340.448,328.773,340.448 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E0C9"
    },
    d: "M420.28,340.448h-54.04c-4.178,0-7.566-3.387-7.566-7.566v-54.039c0-4.178,3.387-7.565,7.566-7.565 h54.039c4.178,0,7.565,3.387,7.565,7.565v54.039C427.845,337.061,424.458,340.448,420.28,340.448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E0C9"
    },
    d: "M145.76,428.352H91.72c-4.178,0-7.566-3.387-7.566-7.565v-54.039c0-4.178,3.387-7.566,7.566-7.566 h54.039c4.178,0,7.566,3.387,7.566,7.566v54.039C153.325,424.965,149.938,428.352,145.76,428.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E0C9"
    },
    d: "M237.266,428.352h-54.039c-4.178,0-7.566-3.387-7.566-7.565v-54.039 c0-4.178,3.387-7.566,7.566-7.566h54.039c4.178,0,7.566,3.387,7.566,7.566v54.039C244.832,424.965,241.445,428.352,237.266,428.352 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8E0C9"
    },
    d: "M328.773,428.352h-54.039c-4.178,0-7.566-3.387-7.566-7.565v-54.039 c0-4.178,3.387-7.566,7.566-7.566h54.039c4.178,0,7.565,3.387,7.565,7.566v54.039C336.338,424.965,332.951,428.352,328.773,428.352 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD544C"
    },
    d: "M214.653,328.452L214.653,328.452c-1.989,0-3.897-0.79-5.303-2.196l-15.838-15.84 c-2.929-2.929-2.929-7.677,0-10.606s7.678-2.928,10.606,0.001l10.535,10.535l24.875-24.876c2.929-2.928,7.678-2.928,10.606,0 c2.929,2.93,2.929,7.678,0,10.607l-30.179,30.179C218.55,327.662,216.643,328.452,214.653,328.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD544C"
    },
    d: "M397.667,240.548L397.667,240.548c-1.989,0-3.897-0.79-5.303-2.196l-15.838-15.84 c-2.929-2.929-2.929-7.677,0-10.606c2.929-2.928,7.678-2.929,10.606,0.001l10.535,10.535l24.875-24.876 c2.929-2.928,7.678-2.928,10.606,0c2.929,2.93,2.929,7.678,0,10.607l-30.179,30.179 C401.563,239.758,399.656,240.548,397.667,240.548z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DD544C"
    },
    d: "M123.147,328.452c-1.989,0-3.897-0.79-5.303-2.196l-15.839-15.839c-2.929-2.93-2.929-7.678,0-10.607 c2.929-2.928,7.678-2.928,10.606,0l10.536,10.536l24.875-24.876c2.929-2.928,7.678-2.928,10.606,0c2.929,2.93,2.929,7.678,0,10.607 l-30.178,30.179C127.044,327.662,125.136,328.452,123.147,328.452z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFBEB"
    },
    d: "M311.841,457.893V340.988c0-21.588,17.5-39.088,39.088-39.088h116.905L311.841,457.893z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8E0C9"
    },
    points: "311.841,340.988 182.867,457.893 311.841,457.893 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7CEB6"
    },
    d: "M215.458,428.352h21.808c4.178,0,7.566-3.387,7.566-7.565v-19.06L215.458,428.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7CEB6"
    },
    d: "M311.841,359.181H291.77l-24.601,22.299v39.306c0,4.178,3.387,7.565,7.565,7.565h37.107V359.181z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolicitudVacaciones);
export default __webpack_public_path__ + "static/media/solicitud-vacaciones.c09063e0c6baba80603fe63852d7b89a.svg";
export { ForwardRef as ReactComponent };